export const AIRulesLSKey = 'AIRulesLSKey'

export const AI_RULES_URL =
  'https://ads.wpcdn.pl/ai/Regulamin_korzystania_z_Uslugi_Chatbot.pdf'

export const AI_LIST_LIMIT = 10

export const AI_WELCOME_MESSAGE_ID = 'welcome'
